// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__q35TC","title":"tooltip_title__nfhW3","noColor":"tooltip_noColor__Zs4vl","crosshair":"tooltip_crosshair__W8sam"};